import { render, staticRenderFns } from "./DocFaceDetection.vue?vue&type=template&id=9fcc962e&scoped=true"
import script from "./DocFaceDetection.vue?vue&type=script&lang=js"
export * from "./DocFaceDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcc962e",
  null
  
)

export default component.exports